import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NotFound from './pages/NotFound/index';
import Home from './pages/Home/index';
import PostDetail from './pages/PostDetail';
import Auth from './pages/Auth';
import WritePost from './pages/WritePost';
import Archive from './pages/Archive'
import Login from'./pages/Login'
import About from './pages/About'
import './App.css';
function App() {
  return (
    <div className = "App">
      <Router>
        <Routes>
          <Route path="/" element= {<Home />} />
          <Route path = "/Login" element = {<Login />} />
          <Route path = "/PostDetail/:id" element = {<PostDetail />}  />
          <Route path = "/Auth" element = {<Auth />} />
          <Route path = "/Write" element = {<WritePost />} />
          <Route path = "/Archive" element = {<Archive />} />
          <Route path = "About" element = {<About />} />
          <Route path = '/*' element = {<NotFound />} />


        </Routes>
      </Router>
    </div>
  );
}

export default App;
